import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const Protected = () => {
  localStorage.removeItem('tableNumber');
  localStorage.removeItem('tableTimestamp');

  const token = localStorage.getItem('token');

  return token ? (
    <Navigate to="/admin/admin" />
  ) : (
    <Navigate to="/admin/login" />
  );
};

export default Protected;
